import { render } from "./KillerRobotModal.vue?vue&type=template&id=5478405d&scoped=true"
import script from "./KillerRobotModal.vue?vue&type=script&lang=js"
export * from "./KillerRobotModal.vue?vue&type=script&lang=js"

import "./KillerRobotModal.vue?vue&type=style&index=0&id=5478405d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5478405d"]])

export default __exports__